import { Box } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

export const LinksBox = styled(Box)`
  //margin: 0 54px 0 22px;
  margin: 0;

  @media (max-width: 568px) {
    margin: 0;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};

      @media (max-width: 568px) {
        margin: ${props.margin};
      }
    `}
`;

export const SectionContent = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const LinksButtonBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const LinkButtonsBox = styled(Box)`
  display: flex;

  @media (max-width: 768px) {
    margin: 12px 0 28px;
    justify-content: space-between;
  }
`;

export const TablerIconsBox = styled(Box)`
  display: block;
  margin-top: 15px;
`;

export const TablerIconsItem = styled(Box)`
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px !important;
  padding: 18px 20px;
  width: 82px;
  height: 82px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 23%;
  }

  ${(props) =>
    props.insideUpload &&
    css`
      @media (max-width: 768px) {
        width: auto;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin} !important;
    `}

  ${(props) =>
    props.centerInner &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.resetMargin &&
    css`
      &:nth-child(${props.resetMargin}n + ${props.resetMargin}) {
        margin-right: 0;
      }

      @media (max-width: 768px) {
        margin: 0 0 5px 0;
      }
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      @media (max-width: 767px) {
        width: 100%;
      }
    `}
`;

export const LinkButtonPreviewBox = styled(Box)`
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.insideSection &&
    css`
      margin-top: -45px;

      @media (max-width: 992px) {
        margin-top: 0;
      }
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      margin: 0;

      @media (max-width: 992px) {
        margin: 0;
      }
    `}

  ${(props) =>
    props.isCoupon &&
    css`
      margin-top: 55px;

      @media (max-width: 992px) {
        margin-top: 55px;
      }
    `}

  ${(props) =>
    props.modalLink &&
    css`
      flex: none;
      margin-right: 58px;
      min-width: 450px;
    `}
`;

export const LinkButtonPreviewWrapper = styled(Box)`
  //height: 221px;
`;

export const LinkButtonPreview = styled(Box)`
  width: 450px;
  padding: 35px 20px;
  border: 1px solid var(--border-color);
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.insideHeader &&
    css`
      width: 290px;
      display: flex;
      justify-content: center;
    `}
`;

export const ButtonLinkItem = styled(Box)`
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);

  ${(props) =>
    props.isNotBoxShadow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.footerItem &&
    css`
      cursor: pointer;
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ButtonLinkEditBox = styled(Box)`
  margin-right: 15px;
  display: flex;
  flex-direction: column;

  @media (max-width: 568px) {
    margin-right: 8px;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.social &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 3px;
    `}
`;

export const ButtonLinkContent = styled(Box)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;
`;

export const SwitchDotsIcon = styled.img`
  transform: rotate(90deg);
  width: 24px;
  height: 24px;
`;

export const ButtonLinkCircle = styled(Box)`
  margin: 1px;
  width: 4px;
  height: 4px;
  background: #acb5bf;
  border-radius: 50%;

  ${(props) =>
    props.color &&
    css`
      background: ${props.color};
    `}
`;

export const ButtonLinkContainer = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: 15px;
  padding: 15px 10px 10px 10px;
  min-height: 90px;
  border-radius: 12px;
  background: var(--main-background);
  border: 1px solid #f7f9ff;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);

  &:hover {
    border-color: rgba(197, 215, 253, 0.7);
  }

  @media (max-width: 568px) {
    padding: 10px;
  }

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.isFaqItem &&
    css`
      margin-right: 0;
      padding: 5px 15px;
      min-height: 50px;
      border: 1px solid transparent;
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;

      &:hover {
        border-color: transparent;
      }
    `}
`;

export const ButtonLinkTitle = styled(Box)`
  margin-bottom: 8px;
  max-height: 41px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  font-weight: bold;
  max-width: 360px;

  @media (max-width: 568px) {
    font-size: 16px;
  }

  ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${props.fontWeight};
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.isNotDescription &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      margin: 0;
      max-height: 50px;
    `}

  ${(props) =>
    props.isOneLine &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  ${(props) =>
    props.customMusic &&
    css`
      padding: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.click &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.blog &&
    css`
      max-width: 300px;
    `}

  ${(props) =>
    props.highlight &&
    css`
      // max-width: 300px;
    `}

    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ButtonLinkDescription = styled(Box)`
  overflow: hidden;

  ${(props) =>
    props.grey &&
    css`
      font-size: 14px;
      color: var(--secondary-gray);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-height: 14px;
    `}

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
  ${(props) =>
    props.insideLinks &&
    css`
      margin: 5px 0 0 0;
      max-height: 65px;
      font-size: 12px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.customMusic &&
    css`
      font-size: 14px;
    `}

  ${(props) =>
    props.isOneLine &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const ButtonLinkWrapper = styled(Box)`
  display: flex;
  width: 100%;
  overflow: hidden;
  ${(props) =>
    props.overflow &&
    css`
      overflow: ${props.overflow};
    `}
`;

export const ButtonIconBox = styled(Box)`
  display: flex;
  flex: none;
  margin-right: 8px;

  ${(props) =>
    props.size &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}
`;

export const ButtonIcon = styled.img`
  width: 38px;
  height: 38px;
  object-fit: cover;

  ${(props) =>
    props.isBigger &&
    css`
      width: 43px;
      height: 43px;
      margin-left: -3px;
    `}

  ${(props) =>
    props.isCircle &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.isRadius &&
    css`
      border-radius: 8px;
    `}

    ${(props) =>
    props.custom &&
    css`
      margin-left: 7px;
    `}
`;

export const ButtonText = styled(Box)`
  @media (max-width: 568px) {
    width: 70%;
  }

  ${(props) =>
    props.gap &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: ${props.gap};
    `}
`;

export const ButtonLinkMenu = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${(props) =>
    props.isFaqItem &&
    css`
      flex-direction: row;
      margin-left: auto;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      flex-direction: row;
      margin-left: 0;
    `}

  ${(props) =>
    props.marginMenu &&
    css`
      margin: ${props.marginMenu};
    `}
`;

export const ButtonLinkMenuItem = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background: var(--input-background);
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #0a3fff;
  }

  &:first-child {
    margin-bottom: 10px;
  }

  ${(props) =>
    props.cover &&
    css`
      position: relative;
      margin: 0 10px;
      background: transparent;

      &:hover {
        background: transparent;
      }
    `}

  ${(props) =>
    props.nohover &&
    css`
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);

      &:hover {
        background: var(--input-background);
      }
    `}

    ${(props) =>
    props.onlyNoHover &&
    css`
      &:hover {
        background: var(--input-background);
      }
    `}


  ${(props) =>
    props.isFaqItem &&
    css`
      margin-bottom: 0;
      margin-right: 10px;

      &:first-child {
        margin-bottom: 0;
      }
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      width: 28px;
      height: 28px;
      border-radius: 5px;
    `}

  ${(props) =>
    props.page &&
    css`
      width: 24px;
      height: 24px;
      border-radius: 8px;

      &:first-child {
        margin: 0;
      }
    `}



  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};

      &:first-child {
        margin: ${props.margin};
      }
    `}

  ${(props) =>
    props.isSettings &&
    css`
      position: absolute;
      z-index: 99;
      top: 50%;
      margin-top: -22px;
      right: 0;
    `}
`;

export const ButtonLinkCategoryImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  object-fit: cover;
`;
